<template>
  <div
    v-if="requestLogs.length"
    class="modal-footer justify-content-start flex-column align-items-start"
  >
    <div class="modal-title flex-fill">
      <h5>Requests update history</h5>
    </div>
    <div class="table-responsive flex-fill w-100">
      <table class="table table-bordered table-striped table-sm">
        <thead class="table-dark">
          <tr>
            <th>Staff Name</th>
            <th>Edited At</th>
            <th>Old Data</th>
            <th>Updated Data</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(log, idx) in requestLogs"
            :key="idx"
          >
            <td>{{ log.staff.user.full_name }}</td>
            <td>{{ log.updated_at | moment('ddd, MMM DD, YYYY LTS') }}</td>
            <td>
              <ul
                v-if="log.old_data"
                class="list-group list-group-flush"
              >
                <li class="list-group-item">
                  <span class="fw-bold">
                    Duration:
                  </span> {{ log.old_data.duration }}
                </li>
                <li class="list-group-item">
                  <span class="fw-bold">Hourly Rate:</span> {{ log.old_data.hourly_rate }}
                </li>
                <li class="list-group-item">
                  <span class="fw-bold">Remarks:</span> {{ log.old_data.remarks }}
                </li>
              </ul>
              <span v-else>None</span>
            </td>
            <td>
              <ul
                v-if="log.new_data"
                class="list-group list-group-flush"
              >
                <li class="list-group-item">
                  <span class="fw-bold">Duration:</span> {{ log.new_data.duration }}
                </li>
                <li class="list-group-item">
                  <span class="fw-bold">Hourly Rate:</span> {{ log.new_data.hourly_rate }}
                </li>
                <li class="list-group-item">
                  <span class="fw-bold">Remarks:</span> {{ log.new_data.remarks }}
                </li>
              </ul>
              <span v-else>None</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
    name: "PaymentRequestUpdateLogs",
    props: {
        requestLogs: {
            type: Array,
            default: () => []
        }
    }
}
</script>

<style scoped>
    .list-group, .list-group-item {
        background-color: inherit;
    }
</style>
